import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=72347bca&scoped=true&"
import script from "./CardLayout.vue?vue&type=script&lang=js&"
export * from "./CardLayout.vue?vue&type=script&lang=js&"
import style0 from "./CardLayout.vue?vue&type=style&index=0&id=72347bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72347bca",
  null
  
)

export default component.exports